// extracted by mini-css-extract-plugin
module.exports = {"division":"index__division___1E8Oo","default":"index__default___2Scw4","white":"index__white___3bwN-","vertical":"index__vertical___3zDp5","blue":"index__blue___HRRXg"};